<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formCadastro.status"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Nome Grupo</span>
          <vs-input
            size="large"
            class="w-full"
            name="Nome"
            id="Nome"
            v-model="formCadastro.nomeGrupo"
            v-validate="{ required: true, min: 3 }"
            :state="validateState('Nome')"
            :danger="validateClass('Nome')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Descrição</span>

          <vs-input
            size="large"
            class="w-full"
            name="Descrição"
            id="Descrição"
            v-model="formCadastro.descricao"
            :state="validateState('Descrição')"
            :danger="validateClass('Descrição')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Descrição Produtos</span>
          <vs-textarea
            class="vs-inputx"
            v-model="formCadastro.descricaoProdutos"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Tipo</span>
          <v-select
            :options="tipos"
            name="Tipo"
            id="Tipo"
            v-model="formCadastro.idTipoFipe"
            v-validate="{ required: true }"
            :state="validateState('Tipo')"
            :class="validateClass('Tipo')"
          ></v-select>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Percentual de Cobertura</span>
          <vs-input
            type="number"
            size="large"
            class="w-full"
            name="Percentual de Cobertura"
            id="Percentual de Cobertura"
            v-model="formCadastro.porcentagemCobertura"
            v-validate="{ required: true }"
            :state="validateState('Percentual de Cobertura')"
            :danger="validateClass('Percentual de Cobertura')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Percentual de Participação</span>
          <vs-input
            type="number"
            step="0.001"
            size="large"
            class="w-full"
            name="Percentual de Participação"
            id="Percentual de Participação"
            v-model="formCadastro.porcentagemParticipacao"
            v-validate="{ required: true }"
            :state="validateState('Percentual de Participação')"
            :danger="validateClass('Percentual de Participação')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Valor Minimo de Participação</span>
          <money
            class="w-full vs-inputx vs-input--input large"
            name="Valor Minimo"
            id="Valor Minimo"
            v-model="formCadastro.valorMinimoParticipacao"
            v-validate="{ required: true }"
            :state="validateState('Valor Minimo')"
            :danger="validateClass('Valor Minimo')"
            v-bind="money"
          ></money>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Valor Complemento de Participação</span>
          <money
            class="w-full vs-inputx vs-input--input large"
            name="Valor Complemento"
            id="Valor Complemento"
            v-model="formCadastro.valorComplementoParticipacao"
            v-validate="{ required: true }"
            :state="validateState('Valor Complemento')"
            :danger="validateClass('Valor Complemento')"
            v-bind="money"
          ></money>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Ano Mínimo de Fabricação</span>
          <vs-input
            size="large"
            class="w-full"
            name="Ano Mínimo de Fabricação"
            id="Ano Mínimo de Fabricação"
            v-model="formCadastro.anoInicio"
            v-mask="'####'"
          ></vs-input>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Ano Máximo de Fabricação</span>
          <vs-input
            size="large"
            class="w-full"
            name="Ano Máximo de Fabricação"
            id="Ano Máximo de Fabricação"
            v-model="formCadastro.anoFim"
            v-mask="'####'"
          ></vs-input>
        </div>
      </div>

      <div class="vx-row" v-if="verificaEmpresa">
        <div class="vx-col mb-6">
          <span>Grupo de veículos importado?</span>
          <vs-switch
            color="success"
            v-model="formCadastro.importado"
            style="width: 60px"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Exibir Extrato Rateio (sga)</span>
          <vs-switch
            color="success"
            v-model="formCadastro.exibirExtratoRateio"
            style="width: 60px"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Gerar cobrança Rateio (sga)</span>
          <vs-switch
            color="success"
            v-model="formCadastro.gerarCobrancaRateio"
            style="width: 60px"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Exibir Participação na Proposta</span>
          <vs-switch
            color="success"
            v-model="formCadastro.exibirParticipacaoProposta"
            style="width: 60px"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col">
          <span>Permitir Implemento</span>
          <vs-switch
            color="success"
            v-model="formCadastro.permiteImplemento"
            style="width: 60px"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col mb-3">
          <span>Permitir agregado</span>
          <vs-switch
            color="success"
            v-model="formCadastro.permiteAgregado"
            style="width: 60px"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>

        <div class="vx-col mb-3">
          <span>Permitir Somente agregado</span>
          <vs-switch
            color="success"
            v-model="formCadastro.permiteSomenteAgregado"
            style="width: 60px"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>

        <div class="vx-col mb-3">
          <span>Permitir Somente RCVAT</span>
          <vs-switch
            color="success"
            v-model="formCadastro.isRcvat"
            style="width: 60px"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>

        <!-- grupos para agregados -->
        <div v-if="formCadastro.permiteAgregado" class="vx-col w-full mb-6">
          <span>Associar grupos para agregados</span>

          <v-select
            :options="gruposAgregados"
            name="Grupos para implementos"
            id="Grupos para implementos"
            v-model="formCadastro.gruposAgregados"
            label="label"
            :state="validateState('Grupos para implementos')"
            :class="validateClass('Grupos para implementos')"
            multiple
          >
            <template #option="{ label, descricaoProdutos }">
              <div style="padding-bottom: 5px">
                <b style="margin: 0; display: block">{{ label }}</b>
                <em v-if="descricaoProdutos" style="margin: 5px">{{
                  descricaoProdutos
                }}</em>
              </div>
            </template>
          </v-select>
        </div>
        <!-- grupos para agregados  -->
      </div>

      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="this.dados.idGrupo == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>

    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from './../../locale';
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import service from '../../services';
import functions from '../../utils/functions';
import BotaoSubmit from '../../components/BotaoSubmit';
import { Money } from 'v-money';
import jwt from 'jsonwebtoken';
import Datepicker from 'vuejs-datepicker';
export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
  },
  watch: {
    dados() {
      this.preencheForm();
    },
    'formCadastro.permiteAgregado': function (value) {
      if (value) {
        this.buscaDadosGrupos();
      }
    },
  },
  computed: {
    verificaEmpresa() {
      return functions.verificaEmpresaBemProtege(this.idEmpresa);
    },
  },
  data() {
    return {
      gruposAgregados: [],
      money: {
        decimal: '.',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: 2,
      },
      aguardeCadastro: false,
      idEmpresa: null,
      languages: lang,
      funcoesValicao: null,
      tipos: [],
      formCadastro: {
        idGrupo: null,
        idEmpresa: null,
        status: true,
        idTipoFipe: null,
        nomeGrupo: '',
        porcentagemCobertura: '',
        descricao: null,
        descricaoProdutos: null,
        importado: false,
        porcentagemParticipacao: '',
        valorMinimoParticipacao: '',
        valorComplementoParticipacao: '',
        exibirExtratoRateio: false,
        gerarCobrancaRateio: false,
        exibirParticipacaoProposta: false,
        permiteImplemento: false,
        permiteAgregado: false,
        permiteSomenteAgregado: false,
        isRcvat: false,
        gruposAgregados: [],
        anoInicio: null,
        anoFim: null,
      },
    };
  },
  methods: {
    decoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        const decoded = jwt.decode(token);
        this.idUsuario = decoded.id_usuario;
        this.idEmpresa = decoded.id_empresa;
      }
    },
    preencheForm() {
      if (this.dados.idGrupo) {
        this.formCadastro.idGrupo = this.dados.idGrupo;
        this.formCadastro.status = this.dados.deletedAt == null ? true : false;
        this.formCadastro.nomeGrupo = this.dados.nomeGrupo;
        this.formCadastro.porcentagemCobertura =
          this.dados.porcentagemCobertura;
        this.formCadastro.descricao = this.dados.descricao;
        this.formCadastro.descricaoProdutos = this.dados.descricaoProdutos;
        this.formCadastro.porcentagemParticipacao =
          this.dados.porcentagemParticipacao;
        this.formCadastro.valorMinimoParticipacao =
          this.dados.valorMinimoParticipacao == null
            ? 0
            : this.dados.valorMinimoParticipacao;

        this.formCadastro.valorComplementoParticipacao =
          this.dados.valorComplementoParticipacao == null
            ? 0
            : this.dados.valorComplementoParticipacao;
        this.formCadastro.idTipoFipe = {
          id: this.dados.idTipoFipe,
          label: this.dados.Tipo,
        };
        this.formCadastro.importado = this.dados.importado;
        this.formCadastro.exibirExtratoRateio = this.dados.exibirExtratoRateio;
        this.formCadastro.gerarCobrancaRateio = this.dados.gerarCobrancaRateio;
        this.formCadastro.exibirParticipacaoProposta =
          this.dados.exibirParticipacaoProposta;

        this.formCadastro.permiteImplemento = this.dados.permiteImplemento;
        this.formCadastro.permiteAgregado = this.dados.permiteAgregado;
        this.formCadastro.permiteSomenteAgregado =
          this.dados.permiteSomenteAgregado;
        this.formCadastro.isRcvat = this.dados.isRcvat;

        this.formCadastro.anoInicio = this.dados.anoInicio;
        this.formCadastro.anoFim = this.dados.anoFim;

        this.formCadastro.gruposAgregados = JSON.parse(
          this.dados.gruposAgregados,
        );
      } else {
        this.resetForm();
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    onSubmit() {
      this.formCadastro.idEmpresa = this.idEmpresa;

      var action = 'Atualizar';
      var msgRetorno = 'Dados Atualizados com sucesso';
      if (!this.formCadastro.idGrupo) {
        action = 'Adicionar';
        msgRetorno = `Registro Adicionado com sucesso`;
      }

      if (this.formCadastro.anoFim === '') {
        this.formCadastro.anoFim = null;
      }
      if (this.formCadastro.anoInicio === '') {
        this.formCadastro.anoInicio = null;
      }

      const foiValidado = this.validaAnosFabricacao(
        this.formCadastro.anoInicio,
        this.formCadastro.anoFim,
      );
      if (foiValidado == false) {
        return;
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service
            .post('Grupo', action, this.formCadastro)
            .then((res) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: `Operação Realizada com sucesso`,
                color: 'success',
              });
              this.$emit('concluido');
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
            });
        }
      });
    },

    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });
      });
    },

    resetForm() {
      this.formCadastro = {
        idGrupo: null,
        idEmpresa: null,
        status: true,
        nomeGrupo: '',
        porcentagemCobertura: '',
        descricao: null,
        descricaoProdutos: null,
        porcentagemParticipacao: '',
        valorMinimoParticipacao: '',
        valorComplementoParticipacao: '',
        exibirExtratoRateio: false,
        gerarCobrancaRateio: false,
        exibirParticipacaoProposta: false,
        permiteImplemento: false,
        permiteAgregado: false,
        permiteSomenteAgregado: false,
        isRcvat: false,
        gruposAgregados: [],
        anoInicio: null,
        anoFim: null,
      };
    },
    onReset(evt) {
      if (this.sideBar == true) {
        this.$emit('cancel');
      } else {
        evt.preventDefault();
        this.resetForm();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },
    async buscaDadosGrupos() {
      if (!this.formCadastro.idTipoFipe.id) return;

      this.gruposAgregados = [];
      const idEmpresa = localStorage.getItem('idEmpresa');

      this.$vs.loading();

      const { data } = await service.getAll('Grupo', {}, 'list/' + idEmpresa);

      data.forEach((element) => {
        if (!element.deletedAt) {
          if (element.idTipoFipe == this.formCadastro.idTipoFipe.id)
            this.gruposAgregados.push({
              id: element.idGrupo,
              label: element.nomeGrupo,
              idTipoFipe: element.idTipoFipe,
              descricaoProdutos: element.descricaoProdutos,
              permiteAgregado: element.permiteAgregado,
              permiteSomenteAgregado: element.permiteSomenteAgregado,
              isRcvat: element.isRcvat,
              permiteImplemento: element.permiteImplemento,
              porcentagemParticipacao: element.porcentagemParticipacao,
              valorMinimoParticipacao: element.valorMinimoParticipacao,
            });
        }
      });

      this.$vs.loading.close();
    },

    validaAnosFabricacao(anoInicio, anoFim) {
      if ((!anoInicio && anoFim) || (anoInicio && !anoFim)) {
        this.$vs.notify({
          position: 'top-center',
          color: 'danger',
          title: 'Erro',
          text: 'Favor preencher ou apagar ambos os campos de Ano de Fabricação',
        });
        return false;
      }

      if (parseInt(anoInicio) > parseInt(anoFim)) {
        this.$vs.notify({
          position: 'top-center',
          color: 'danger',
          title: 'Erro',
          text: 'O Ano Mínimo de Fabricação precisa ser menor que o Ano Máximo de Fabricação',
        });
        return false;
      }

      return true;
    },
  },
  mounted() {
    this.buscaDadosSelects('domTipoFipe', 'tipos', 'nomeTipo', 'idTipoFipe');
    this.$validator.localize('ptBr', locale);
    this.decoded();
  },
  components: {
    Money,
    BotaoSubmit,
    'v-select': vSelect,
  },
};
</script>
<!------------ END SCRIPT ------------>
<style scoped>
.vs-con-textarea {
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
}
</style>
